const customers = {
  list: {
    search: 'Search for customer name, phone number or email',
    noDataDescription: 'No customers yet',
    customerId: 'Customer ID',
    name: 'Name',
    branchName: 'Branch Name',
    phoneNumber: 'Phone Number',
    branch: 'Branch',
    status: 'Status',
    filter: {
      filtersPlaceHolders: {
        filterByService: 'Filter by service',
        filterByCustomerStatus: 'Filter by status',
        filterByBranchName: 'Filter by branch name',
        filterByLocations: 'Filter by locations',
      },
    },
    statusCases: {
      active: 'Active',
      blocked: 'Blocked',
    },
    blockCustomer:'Block customer',
    blockCustomerMsg: 'Are you sure you want to block this customer? ',
    note:'Note that',
    blockCustomerNote:'Customer’s upcoming bookings will be cancelled.',
  },
  deleteCustomer: {
    title: 'Delete customer',
    deleteConfirmationMsg: 'Are you sure you want to delete the customer?',
  },
  errorMessages: {
    phoneRequired: 'Phone number is required',
  },
  viewCustomer: {
    gender: 'Gender',
    addresses: 'Customer saved addresses',
    title: 'Title',
    country: 'Country',
    city: 'City',
    region: 'Region',
    streetName: 'Street name',
    buildingNumber: 'Building number',
    secondaryPhone: 'Secondary phone',
    landmark: 'Landmark',
    email: 'Email',
    noAddress: 'No addresses found',
    address: 'Address',
    female:'Female',
    male:'Male'
  },
};

export default customers;
